module.exports = __webpack_public_path__ + "static/Feature-4-1894f0ae36d8063f97b1c233447cf15d.svg";